<template>
  <b-card header="Logs de Comissões">
    <b-alert v-if="items.length === 0" show variant="secondary">
      Nenhum log encontrado no período selecionado
    </b-alert>

    <b-table v-else responsive striped hover :items="items" :fields="fields">
      <template #cell(points)="data">
        <b-badge :variant="data.item.points < 0 ? 'danger' : 'success'">
          {{ data.item.points > 0 ? '+' : '' }}{{ data.item.points }}
        </b-badge>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { formatCurrency } from '@/helpers/numbers'
import { formatStandardDateTime } from '@/helpers/date'

const REASON_LABELS = {
  rent_started: 'Aluguel iniciado',
  rent_canceled: 'Aluguel cancelado',
  rent_recovered: 'Aluguel reaberto',
  manual_adjustment: 'Ajuste manual'
}

export default {
  name: 'CommissionsLogList',
  props: {
    report: {
      type: Object,
      default: () => ({ data: { logs: [] } })
    }
  },
  data() {
    return {
      fields: [
        { key: 'createdAt', label: 'Data' },
        { key: 'userName', label: 'Funcionário' },
        { key: 'reason', label: 'Motivo' },
        { key: 'points', label: 'Vendas' },
        { key: 'amount', label: 'Valor' },
        { key: 'periodMinutes', label: 'Período' }
      ]
    }
  },
  computed: {
    items() {
      return (this.report?.data?.logs || []).map((item) => ({
        ...item,
        createdAt: formatStandardDateTime(item.createdAt),
        reason: REASON_LABELS[item.reason] || item.reason,
        amount: formatCurrency(item.amount),
        periodMinutes: this.formatMinutes(item.periodMinutes)
      }))
    }
  },
  methods: {
    formatMinutes(value) {
      const minutes = Number(value || 0)
      return minutes ? `${minutes}min` : '-'
    }
  }
}
</script>
